import { CrfCheckItemSpec, CrfSingleSelectItemSpec, EdcGroupId, InitialItemSequence } from "maven-lib/dist/consts/edc";
import { CrfCapturableFlattenItemSpec, ECoaDescriptionFlattenItemSpec } from "maven-lib/dist/consts/edc/lib";

export function makeCaptureData(
  questionnaireItem: CrfCapturableFlattenItemSpec | ECoaDescriptionFlattenItemSpec,
  answer: { itemId: string | null; dbVal: string | number | null },
  defaultDbVal: string | number | null,
  folderId: string,
  visitId: string,
  visitSeq: number,
  crfPageId: string,
  crfPageSeq: number
) {
  const itemId: string = (() => {
    if (questionnaireItem.type === "DATE") {
      if (questionnaireItem.id === answer.itemId) {
        return questionnaireItem.id;
      } else {
        const children = questionnaireItem.original.children?.items.find(
          (childrenItem) => childrenItem.type === "TIME" && childrenItem.id === answer.itemId
        );
        return children ? answer.itemId || "" : "";
      }
    }
    return answer?.itemId || questionnaireItem?.id || "";
  })();

  const getCalcVal = (): string | number | null => {
    if (questionnaireItem.type === "CHECK" || questionnaireItem.type === "SINGLE_SELECT") {
      const itemSpec = questionnaireItem.original as CrfCheckItemSpec | CrfSingleSelectItemSpec;

      if (questionnaireItem.type === "CHECK" && itemSpec.id !== answer.itemId) return null;
      else return itemSpec.itemCode.codes.find((x) => x.dbVal === answer?.dbVal)?.calcVal ?? null;
    }
    // NOTE: dbVal 이 object 타입인 경우에는 calcVal 이 동반되는 케이스가 없음에 따라 위와 같이 처리함.
    return null;
  };

  return {
    id: {
      groupId: EdcGroupId,
      folderId,
      visitId,
      visitSeq,
      crfPageId,
      crfPageSeq,
      sectionId: questionnaireItem.sectionId,
      itemId,
      itemSeq: questionnaireItem.original.itemSeq || InitialItemSequence,
    },
    val: {
      dbVal: answer?.dbVal || typeof answer?.dbVal === "number" || typeof answer?.dbVal === "object" ? answer?.dbVal : defaultDbVal,
      calcVal: getCalcVal(),
    },
  };
}
